/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { RatingsSummary } from '@msdyn365-commerce/commerce-entities';
import {
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric,
    sendRequest
} from '@msdyn365-commerce/core';

import { getRnrEndpointId, getRnrPartnerId } from './utilities/getRnrKeys';
import { getSelectedProductIdFromActionInput } from './utilities/rating-utils';
import { GetRatingsSummaryInput } from './get-ratings-summary-input';

export const createInput = (input: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    const productId = getSelectedProductIdFromActionInput(input);
    if (productId) {
        return new GetRatingsSummaryInput(productId, getRnrPartnerId(input), getRnrEndpointId(input));
    }
    throw new Error('[GetRatingsSummary] Not all necessary parameters found while creating Input for getRatingsSummaryApi');
};

/**
 * This function gets the ratings summary.
 * @param input
 * @param ctx
 */
export async function getRatingsSummary(input: GetRatingsSummaryInput, ctx: IActionContext): Promise<RatingsSummary> {
    return {};
}

function inputIsValid(input: GetRatingsSummaryInput): boolean {
    return input && input.productId.length > 0 && input.tenantId.length > 0;
}

export const getRatingsSummaryDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/get-ratings-summary',
    action: <IAction<RatingsSummary>>getRatingsSummary,
    input: createInput
});

export default getRatingsSummaryDataAction;
